import ModalManager from '@/utils/modal';
import { QuizActions } from "@/store/modules/quiz/actions";
import { QuizGetters } from "@/store/modules/quiz/getters";
import { STATE_MODULES } from "@/store/state-modules";
import { AnsweredQuestion, Question, skillAssessmentConstants } from "@puls/puls-common-constants";
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export const SkillAssessmentQuizStatues = defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			isQuizLoaded: QuizGetters.IS_QUIZ_LOADED,
			isQuizFailed: QuizGetters.IS_QUIZ_ATTEMPT_FAILED,
			isQuizPassed: QuizGetters.IS_QUIZ_PASSED,
			isFirstTimeQuiz: QuizGetters.IS_FIRST_TIME_QUIZ_NOT_STARTED,
			isFailedAndHaveRetry: QuizGetters.IS_HAVE_RETRY,
			isQuizInProgress: QuizGetters.IS_QUIZ_IN_PROGRESS
		})
	}
});

export const QuestionPropMixin = defineComponent({
	props: {
		question: {
			type: Object as () => Question,
			required: true
		}
	}
})

export const QuestionItemMixin = defineComponent({
	mixins: [QuestionPropMixin],
	computed: {
		selectedAnswers: {
			get (): string | string[] {
				const currentQuestion = this.$store.getters[`${STATE_MODULES.QUIZ}/${QuizGetters.GET_QUESTION_BY_UUID}`](this.question.uuid) as AnsweredQuestion;
				switch (this.question.type) {
				case skillAssessmentConstants.SKILL_ASSESSMENT_QUESTIONS_TYPES.SINGLE_QUESTION:
				case skillAssessmentConstants.SKILL_ASSESSMENT_QUESTIONS_TYPES.OPEN_QUESTION:
					if (!currentQuestion?.answers) {
						return '';
					}
					return currentQuestion?.answers[0] || '';
				case skillAssessmentConstants.SKILL_ASSESSMENT_QUESTIONS_TYPES.MULTIPLE_QUESTION:
					return currentQuestion?.answers || [];
				default:
					return []
				}
			},
			set (value: string | string[]) {
				let answers = value;
				
				if (!Array.isArray(answers)) {
					answers = [answers].filter(a => a); // empty text
				}

				this.$store.dispatch(`${STATE_MODULES.QUIZ}/${QuizActions.ANSWER_QUESTION}`, { uuid: this.question.uuid, answers })
			}
		}
	}
})

export const OpenReviewModalMixin = defineComponent({
	methods: {
		async openReview () {
			const comp = (await import('@/components/modals/ReviewQuizAnswers.vue')).default
			ModalManager.open(comp)
		}
	}
})
